import { Outlet } from 'react-router-dom';

export default function ReservationLayout() {
    return (
        <div className="flex flex-col h-full space-y-6">
            {/* Content */}
            <div className="flex-1">
                <Outlet />
            </div>
        </div>
    );
}
